module.exports = __webpack_public_path__ + "img/edit-color.5dfce57d.svg";